// @flow
type SetSchema = 'bravissimolabs/schema/SET';
export const SET_SCHEMA: SetSchema = 'bravissimolabs/schema/SET';
